function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c8564a63273a2e5182f858b8ed02aa107{fill: currentColor;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "c8564a63273a2e5182f858b8ed02aa107",
  d: "M28.1,14.067V7.793A1.8,1.8,0,0,0,26.3,6H4.793A1.8,1.8,0,0,0,3,7.793V25.719a1.8,1.8,0,0,0,1.793,1.793H26.3A1.8,1.8,0,0,0,28.1,25.719V19.444L32.2,23.549a1.8,1.8,0,0,0,3.065-1.273V11.216A1.8,1.8,0,0,0,32.2,9.944Zm-7.171,4.481H17.341v3.585a1.793,1.793,0,0,1-3.585,0V18.548H10.171a1.793,1.793,0,1,1,0-3.585h3.585V11.378a1.793,1.793,0,0,1,3.585,0v3.585h3.585a1.793,1.793,0,1,1,0,3.585Z",
  transform: "translate(-3 -6)"
});

function SvgVideoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.267,
    height: 21.511,
    viewBox: "0 0 32.267 21.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.c757bb9d.svg";
export { ForwardRef as ReactComponent };